module.exports = "\n<p></p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/authentication/auth-callback/auth-callback.component.html
// module id = 1712
// module chunks = 0